// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PreHeader_wrapper__7T4cw","h42":"PreHeader_h42__p2HKU"};